export const DENMARK = 'DK';
export const SWEDEN = 'SE';
export const NORWAY = 'NO';
export const FINLAND = 'FI';
export const BRITAIN = 'GB';
export const LUXEMBOURG = 'LU';
